/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2, breakpoints } from '@coursera/cds-core';

import CoachButton from 'bundles/unified-description-page-common/components/coach/CoachButton';

import _t from 'i18n!nls/xdp';

const styles = {
  coachButtonContainer: css`
    display: inline-flex;
    gap: var(--cds-spacing-200);
    background-color: var(--cds-color-emphasis-primary-background-xweak);
    border-radius: var(--cds-border-radius-max);
    padding-top: var(--cds-spacing-50);
    padding-bottom: var(--cds-spacing-50);
    padding-left: var(--cds-spacing-50);
    padding-right: var(--cds-spacing-200);
    align-items: center;
    justify-content: start;

    ${breakpoints.down('sm')} {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: var(--cds-spacing-100);
      border-radius: var(--cds-border-radius-200);
      padding: var(--cds-spacing-100) var(--cds-spacing-150);
      margin-top: var(--cds-spacing-100);
      margin-bottom: var(--cds-spacing-300);
    }
  `,
  coachButton: css`
    flex-shrink: 0;

    .animation-wrapper::before {
      background: var(--cds-color-neutral-background-primary);
    }
  `,
};

const CoachButtonWithDescription = () => {
  return (
    <div css={styles.coachButtonContainer}>
      <CoachButton css={styles.coachButton} />
      <Typography2 component="p" variant="bodySecondary">
        {_t('Chat with Coursera AI to see how this certificate aligns with your career path.')}
      </Typography2>
    </div>
  );
};

export default CoachButtonWithDescription;
